export default "__VITE_ASSET__a99db26e__"